const clearWorkflowsUsingCredentials = ({ commit }) => {
  commit('SET_WORKFLOWS_USING_CREDENTIALS', []);
};

export default clearWorkflowsUsingCredentials;
